// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import {
  castToString,
  ifEntityGetId,
} from 'helpers/reduxFormFunctions'

import {
  epochToYYYYMMDDinEST,
} from 'helpers/timeConversion'

const administrationDataForForm = p => {
  const {
    protectFlag,
  } = p

  const expirationDate = epochToYYYYMMDDinEST(p.expirationDate) || ''
  const licenseDate = epochToYYYYMMDDinEST(p.licenseDate) || ''
  const publicNoticeDate = epochToYYYYMMDDinEST(p.publicNoticeDate) || ''
  const segmentStatusId = ifEntityGetId(p.segmentStatus)
  const ulsFileNumber = castToString(p.ulsFileNumber)

  return {
    expirationDate,
    licenseDate,
    protectFlag,
    publicNoticeDate,
    segmentStatusId,
    ulsFileNumber,
  }
}

export default administrationDataForForm
